module.exports = {};



//////////////////
// WEBPACK FOOTER
// /Users/v625154/work/perspective/node_modules/core-js/modules/_iterators.js
// module id = 32
// module chunks = 0